import React from 'react';
import ActionsMenu from '../../../../components/ActionsMenu';

/**
 * FamilyHeader component
 * Header section for the stats view with family name and action buttons
 */
export default function FamilyHeader({
    selectedFamily,
    activeProjectName,
    onExportFamily,
    onEditFamily,
    onShareFamily,
    onDeleteFamily
}) {
    return (
        <>
            <header style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                <div>
                    <h1 style={{ fontSize: '1.35rem', margin: 0, color: 'var(--text-primary)' }}>
                        {selectedFamily.name}
                    </h1>
                    <p style={{ color: 'var(--text-secondary)', fontSize: '0.85rem', margin: '0.25rem 0 0 0' }}>
                        Last updated by <span style={{ fontWeight: 600 }}>{selectedFamily.lastChangeUser || 'System'}</span> on <span style={{ fontWeight: 600 }}>{new Date(selectedFamily.lastChangeDate).toLocaleString()}</span>
                    </p>
                </div>
                <ActionsMenu
                    label="Family actions"
                    items={[
                        {
                            label: 'Export Family',
                            icon: 'fa-solid fa-file-export',
                            onSelect: () => onExportFamily(selectedFamily.id, selectedFamily.name)
                        },
                        {
                            label: 'Edit Family',
                            icon: 'fa-solid fa-pen',
                            onSelect: (event) => onEditFamily(event, selectedFamily.id)
                        },
                        {
                            label: 'Share with project',
                            icon: 'fa-solid fa-share-nodes',
                            onSelect: () => onShareFamily(selectedFamily)
                        },
                        {
                            label: 'Delete Family',
                            icon: 'fa-solid fa-trash-can',
                            danger: true,
                            onSelect: (event) => onDeleteFamily(event, selectedFamily.id)
                        }
                    ]}
                />
            </header>
        </>
    );
}
